class AccordionComponent extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      accordionItem: "[data-accordion-item]",
      accordionButton: "[data-accordion-button]",
      accordionContent: "[data-accordion-content]",
    };

    this.accordionItems = [
      ...this.querySelectorAll(this.selectors.accordionItem),
    ];

    this.group = this.getAttribute("group");
    this.init(this.accordionItems);

    this.addEventListener(
      "DOMNodeInserted",
      function () {
        const newItems = [
          ...this.querySelectorAll(this.selectors.accordionItem),
        ].filter((item) => !this.accordionItems.includes(item));
        this.accordionItems = [...this.accordionItems, ...newItems];
        this.init(newItems);
      },
      false,
    );

    if (this.group) {
      document.addEventListener("global-accordion:opened", (e) => {
        if (e.target === this || e.target.group !== this.group) return;

        this.closeAllAccordions();
      });
    }
  }

  init(items) {
    items.forEach((item) => {
      const button = item.querySelector(this.selectors.accordionButton);
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        const item = event.target.closest(this.selectors.accordionItem);

        if (item.classList.contains("active")) {
          this.toggleAccordion(item, false);
        } else {
          this.closeAllAccordions(item);
          this.toggleAccordion(item, true);
        }
      });

      if (item.classList.contains("active")) {
        this.toggleAccordion(item, true);
      }
    });
  }

  closeAllAccordions(currentItem) {
    this.accordionItems.forEach((item) => {
      if (currentItem != item) {
        this.toggleAccordion(item, false);
      }
    });
  }

  toggleAccordion(item, open) {
    if (open) {
      this.openAccordion(item);
    } else {
      this.closeAccordion(item);
    }
  }

  openAccordion(item) {
    if (item.classList.contains("active")) return;
    this.dispatchEvent(
      new CustomEvent("global-accordion:opened", { bubbles: true }),
    );
    const content = item.querySelector(this.selectors.accordionContent);

    const onEnd = () => {
      content.removeEventListener("transitionend", onEnd);
      content.style.maxHeight = "none";
    };

    content.addEventListener("transitionend", onEnd);
    content.style.maxHeight = `${content.scrollHeight}px`;
    item.classList.add("active");
  }

  closeAccordion(item) {
    if (!item.classList.contains("active")) return;
    const content = item.querySelector(this.selectors.accordionContent);

    content.style.maxHeight = `${content.scrollHeight}px`;

    window.requestAnimationFrame(() => {
      content.style.maxHeight = 0;
      item.classList.remove("active");
    });
  }
}

if (!customElements.get("accordion-component")) {
  customElements.define("accordion-component", AccordionComponent);
}
